import { CheckBox, StyledText, TableWithPagination } from '@clickcease/cc-client-components-lib'
import React from 'react'

import { GenericPlatformEntity } from '../../../models'

import { IdsSelectionRow } from './PaginatedCheckboxModal.styled'

interface IdsListProps {
  accountsToShow: GenericPlatformEntity[]
  selectedAccounts: number[]
  page: number
  pageCount: number
  selectedText?: string
  totalItems?: number
  limitPerPage?: number
  onFirstPage: () => void
  onLastPage: () => void
  onNextPage: () => void
  onPreviousPage: () => void
  handleSelect: (a: number) => void
  isReadOnly?: boolean
  isAllSelected?: boolean
  isLoading?: boolean
}

export const PaginatedEntityList = ({
  isReadOnly,
  accountsToShow,
  selectedAccounts,
  page,
  pageCount,
  totalItems,
  limitPerPage,
  onFirstPage,
  onLastPage,
  onNextPage,
  onPreviousPage,
  handleSelect,
  isAllSelected,
  selectedText,
  isLoading,
}: IdsListProps) => {
  return (
    <TableWithPagination
      body={
        <>
          {accountsToShow.map((account) => (
            <IdsSelectionRow key={account.id}>
              <CheckBox
                isChecked={isAllSelected || selectedAccounts.includes(account.id)}
                onChange={() => handleSelect(account.id)}
                disabled={isReadOnly}
              />
              <StyledText variant={'baseLight'}>{account.name}</StyledText>
              <StyledText variant={'baseLight'}>
                {account.adAccountId ||
                  account.adAccountID ||
                  account.campaignId ||
                  account.managerId ||
                  ''}
              </StyledText>
            </IdsSelectionRow>
          ))}
        </>
      }
      textOfSelection={isLoading ? ' ' : selectedText}
      pageCount={pageCount}
      limitPerPage={limitPerPage}
      currentPage={page}
      totalItems={totalItems}
      onFirstPage={onFirstPage}
      onLastPage={onLastPage}
      onNextPage={onNextPage}
      onPreviousPage={onPreviousPage}
      wrapperStyle={{ height: '100%' }}
      paginationStyle={{ '> nav': { padding: '$6 0 0 0', '> span': { top: '70%' } } }}
    />
  )
}
